

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import VueQrcode from 'vue-qrcode';

import { Surface, Typography, Picture } from '@/components/atoms';
import eventBus from '@/utils/eventBus';

import {
  getAssetsURL,
  IMarketingCenterGetAsset
} from '@/models/marketingCenter/post';
import { EMarketingCenterFormats } from '@/models/marketingCenter/format';

@Component({ components: { VueQrcode, Surface, Typography, Picture } })
export default class MarketingCenterShareModal extends Vue {
  @Prop({ required: true }) postAssets!: IMarketingCenterGetAsset[];
  @Prop(String) postId?: string;
  @Prop(String) readonly gaContextPage!: string;
  instagramTooltip: boolean = false;
  qrCodeLink = '';

  mounted() {
    this.qrCodeLink = getAssetsURL(this.postId || this.$route.params.post);
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  openInstagramTooltip() {
    if (!this.instagramTooltip) {
      this.$analytics({
        eventCategory: `${this.gaContextPage} | Share Modal`,
        eventAction: 'click',
        eventLabel: 'Clicked on the "instagram" option'
      });
    }

    this.instagramTooltip = !this.instagramTooltip;
  }

  shareOnFacebook() {
    const link = this.facebookShareLink
      ? this.facebookShareLink.url
      : this.postAssets[0].url;

    this.$analytics({
      eventCategory: `${this.gaContextPage} | Share Modal`,
      eventAction: 'click',
      eventLabel: 'Clicked on the "facebook" option'
    });

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${link}`,
      '_blank'
    );
  }

  get facebookShareLink() {
    return this.postAssets.find(
      asset => asset.type === EMarketingCenterFormats.facebookPost
    );
  }
}
